import { View, Text as PDFText } from '@react-pdf/renderer'

import { BookingDetail } from '../../../../../types/bookingDetails'
import { bookingStatus, isCancelledStatus } from '../../../statement'
import styles from './stlyes/index.styles'

interface HotelDetailProps {
  data: BookingDetail
}

const HotelDetail = ({ data }: HotelDetailProps) => {
  const { accommodationName, propertyAddress, propertyTelephone } =
    data.basicDetails
  const { shortName, name, paymentNumber } = data.sourceInfo
  const status = bookingStatus(data.basicDetails)

  return (
    <View style={styles.mainDiv}>
      <View style={styles.content}>
        <View style={styles.phoneNumberContainer}>
          <View style={styles.rowDirection}>
            <PDFText style={styles.subjectTitle}>Hotel Name:</PDFText>
            <PDFText style={styles.subjectValue}>{accommodationName}</PDFText>
          </View>
          <View style={styles.rowDirection3}>
            <PDFText style={styles.subjectTitle}>Telephone:</PDFText>
            <PDFText style={styles.subjectValue}>{propertyTelephone}</PDFText>
          </View>
        </View>
        <View style={styles.phoneNumberContainer}>
          <View style={styles.rowDirection2}>
            <PDFText style={styles.subjectTitle}>Hotel Address:</PDFText>
            <PDFText style={styles.subjectValue}>{propertyAddress}</PDFText>
          </View>
        </View>
        <View style={styles.phoneNumberContainer}>
          <View style={styles.rowDirection}>
            <PDFText style={styles.subjectTitle}>Status:</PDFText>
            <PDFText
              style={
                isCancelledStatus(status)
                  ? styles.subjectValueRed
                  : styles.subjectValue
              }>
              {status}
            </PDFText>
          </View>
          <View style={styles.rowDirection3}>
            <PDFText style={styles.subjectTitle}>Channel:</PDFText>
            <PDFText style={styles.subjectValue}>{shortName || name}</PDFText>
          </View>
        </View>
        <View style={styles.phoneNumberContainer}>
          {paymentNumber && (
            <View style={styles.rowDirection2}>
              <PDFText style={styles.subjectTitle}>Payment Number:</PDFText>
              <PDFText style={styles.subjectValue}>{paymentNumber}</PDFText>
            </View>
          )}
          <View />
        </View>
      </View>
    </View>
  )
}
export default HotelDetail
